import ContentCopyIcon from '@offline-mui/icons-material/ContentCopy'
import { IconButton, Tooltip } from '@offline-mui/material'
import { useState } from 'react'

type CopyJsonButtonProps = {
  value: unknown
  label?: string
  size?: 'small' | 'medium'
}

async function writeClipboard(text: string) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

export default function CopyJsonButton({
  value,
  label = 'Copy JSON',
  size = 'small',
}: CopyJsonButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await writeClipboard(JSON.stringify(value, null, 2))
    setCopied(true)
    window.setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Tooltip title={copied ? 'Copied' : label}>
      <IconButton
        size={size}
        aria-label={label}
        onClick={(event) => {
          event.stopPropagation()
          void handleCopy()
        }}
      >
        <ContentCopyIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  )
}

export { writeClipboard }
